/**
 * Coure.RateBillingManagement.API 
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ProblemDetails } from '../model/problemDetails';
import { RateDetail } from '../model/rateDetail';
import { RateDetailCreateDto } from '../model/rateDetailCreateDto';
import { RateDetailUpdateDto } from '../model/rateDetailUpdateDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class RateDetailsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRateDetailsCreateRateDetailPost(body?: RateDetailCreateDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiRateDetailsCreateRateDetailPost(body?: RateDetailCreateDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiRateDetailsCreateRateDetailPost(body?: RateDetailCreateDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiRateDetailsCreateRateDetailPost(body?: RateDetailCreateDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/api/RateDetails/CreateRateDetail`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param rateDetailId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRateDetailsDeleteDelete(rateDetailId?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiRateDetailsDeleteDelete(rateDetailId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiRateDetailsDeleteDelete(rateDetailId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiRateDetailsDeleteDelete(rateDetailId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (rateDetailId !== undefined && rateDetailId !== null) {
            queryParameters = queryParameters.set('rateDetailId', <any>rateDetailId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<string>('delete',`${this.basePath}/api/RateDetails/Delete`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param rateDetailId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRateDetailsGetRateDetailByIdGet(rateDetailId?: string, observe?: 'body', reportProgress?: boolean): Observable<RateDetail>;
    public apiRateDetailsGetRateDetailByIdGet(rateDetailId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RateDetail>>;
    public apiRateDetailsGetRateDetailByIdGet(rateDetailId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RateDetail>>;
    public apiRateDetailsGetRateDetailByIdGet(rateDetailId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (rateDetailId !== undefined && rateDetailId !== null) {
            queryParameters = queryParameters.set('rateDetailId', <any>rateDetailId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<RateDetail>('get',`${this.basePath}/api/RateDetails/GetRateDetailById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param rateId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRateDetailsGetRateDetailsByRateIdGet(rateId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<RateDetail>>;
    public apiRateDetailsGetRateDetailsByRateIdGet(rateId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<RateDetail>>>;
    public apiRateDetailsGetRateDetailsByRateIdGet(rateId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<RateDetail>>>;
    public apiRateDetailsGetRateDetailsByRateIdGet(rateId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (rateId !== undefined && rateId !== null) {
            queryParameters = queryParameters.set('rateId', <any>rateId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<RateDetail>>('get',`${this.basePath}/api/RateDetails/GetRateDetailsByRateId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRateDetailsUpdatePost(body?: RateDetailUpdateDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiRateDetailsUpdatePost(body?: RateDetailUpdateDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiRateDetailsUpdatePost(body?: RateDetailUpdateDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiRateDetailsUpdatePost(body?: RateDetailUpdateDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/api/RateDetails/Update`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
